import React, { ComponentType, PureComponent } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { fetchSites, filterArrivalSites } from '../actions/site';
import { State } from '../../booking/reducers';
import { Api } from '../../common/model';

interface Props {
  sites: Array<Api.Site>;
  switches: Array<Api.SiteSwitch>;
  arrivalSites: Array<Api.Site>;
  fetchSites: () => void;
}

const mapStateToProps = (state: State) => ({ ...state.sites });

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ fetchSites, filterArrivalSites }, dispatch);

export const withSites = (WrappedComponent: ComponentType<Props>) => {
  class WithSites extends PureComponent<Props> {
    static displayName = 'HOC(withSites)';

    componentDidMount = () => this.props.fetchSites();

    render() {
      const { sites, switches, arrivalSites } = this.props;
      return <WrappedComponent {...this.props} sites={sites} switches={switches} arrivalSites={arrivalSites} />;
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithSites);
};
